import httpClient from '@/api/index';

export default {
    loadOptions: function () {
        return httpClient().get('/json/tipe_instansi_options');
    },
}
